import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const ChangeStartDateKabobItem = () => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { pageContentResource } = usePageContentContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleChangeStartDateClick = () => {
    const startDateLink = pageContentResource.relationship(fr.relationships.facetPlanSummary.name)?.link?.('related')?.url();
    if (!startDateLink) {
      return;
    }
    loadModalCollectionByLink(startDateLink);
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'change start date from summary kabob', {
      eventProperties: {
        scenarioId: pageContentResource.id(),
      },
    });
  };

  return (
    <KabobMenuItem
      label={'Change Start Month'}
      test={'facet-plan-summary-kabob-item-start-date'}
      onClick={() => {
        handleChangeStartDateClick();
      }}
    />
  );
};

ChangeStartDateKabobItem.defaultProps = {};

ChangeStartDateKabobItem.propTypes = {};

export default ChangeStartDateKabobItem;
